import { IEventsStore } from '../../events'

export default function(state: IEventsStore): IEventsStore {
  return {
    ...state,
    request: {
      ...state.request,
      events: { ...state.request.events, errMessage: '', isLoading: true },
    },
  }
}
